<script>
  import { fade, fly } from "svelte/transition";
  import { flip } from "svelte/animate";
  import Number from "./Number.svelte";

  export let name;
  export let iso2;
  export let ioc;
  export let index;
  export let rank;
  export let xGold;
  export let xSilver;
  export let xBronze;
  export let metricGold;
  export let metricSilver;
  export let metricBronze;
  export let height;

  $: y = height * index;
</script>

<div
  class="country"
  style="height: {height}px; transform: translate3d(0, {y}px ,0);"
>
  <div class="country-label">
    <div class="rank"><Number number="{rank}" isOrdinal="{true}" /></div>
    <div class="flag">
      <img src="assets/flags/{iso2}.jpg" alt="{iso2}" />
    </div>
    <p>
      <span class="name">{name}</span>
      <span class="ioc">{ioc}</span>
    </p>
  </div>
  <div class="country-medals">
    <div class="medal bronze" style="{`width: ${xBronze}%;`}">
      <span class:visible="{metricBronze > 0}">{metricBronze}</span>
    </div>
    <div class="medal silver" style="{`width: ${xSilver}%;`}">
      <span class:visible="{metricSilver > 0}">{metricSilver}</span>
    </div>
    <div class="medal gold" style="{`width: ${xGold}%;`}">
      <span class:visible="{metricGold > 0}">{metricGold}</span>
    </div>
  </div>
</div>

<style>
  .country {
    --label-width: 7em;
    --medal-width: 2em;
    --radius: 4px;
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    align-items: center;
    width: 100%;
    padding: 0;
    background-color: rgba(0, 0, 0, 0.5);
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    transition: all 1s;
  }

  .country-label {
    display: flex;
    align-items: center;
    white-space: nowrap;
    width: var(--label-width);
    font-size: 1em;
    line-height: 1;
    margin: 0;
    color: var(--bg);
  }

  .name {
    margin: 0;
    display: none;
  }

  .ioc {
    margin: 0;
    display: inline-block;
  }

  .rank {
    font-size: 0.667em;
    width: 2.5em;
    text-align: right;
    margin: 0;
    margin-right: 0.5em;
    opacity: 0.75;
    line-height: 1;
  }

  .flag {
    position: relative;
    margin-right: 0.5em;
    width: 1.5em;
    height: 1.5em;
    background: var(--bg);
    border-radius: var(--radius);
    border: 0px solid var(--bg);
    overflow: hidden;
  }

  .flag :global(svg) {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200%;
    transform: translate(-50%, -50%);
  }

  .country-medals {
    position: relative;
    flex: 1;
    height: 100%;
    align-items: center;
    display: flex;
  }

  .medal {
    text-align: right;
    position: relative;
    transition: all 1s 1s;
  }

  .medal.gold span,
  .medal.gold:before {
    background-color: var(--gold);
    color: var(--gold-dark);
  }

  .medal.silver span,
  .medal.silver:before {
    background-color: var(--silver);
    color: var(--silver-dark);
  }

  .medal.bronze span,
  .medal.bronze:before {
    background-color: var(--bronze);
    color: var(--bronze-dark);
  }

  .medal:before {
    position: absolute;
    display: block;
    content: "";
    height: 4px;
    width: 100%;
    top: 50%;
    left: 0;
    transform: translate(0, -2px);
    z-index: var(--z-middle);
  }

  .medal span {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: var(--radius);
    vertical-align: middle;
    border: 1px solid var(--fg);
    transform: translate(100%, -50%);
    z-index: var(--z-top);
    width: var(--medal-width);
    height: var(--medal-width);
    background-color: currentColor;
    text-align: center;
    line-height: var(--medal-width);
    font-size: 0.7em;
    font-weight: bold;
    opacity: 1;
  }

  .medal span.visible {
    display: inline-block;
  }

  @media only screen and (min-width: 720px) {
    .country {
      --label-width: 13.5em;
    }

    .country-label {
      font-size: 1.25em;
    }

    .name {
      display: inline-block;
    }

    .ioc {
      display: none;
    }

    .medal span {
      font-size: 1em;
    }
  }
</style>
